import React from 'react';
import { UsersIcon, CalendarDaysIcon, ClockIcon } from 'lucide-react';
export function KeyInfo() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2615">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-2616">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-2617">
          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2618">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-2619">
              <UsersIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-2620" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-2621">
              Open to All
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2622">
              FLSC Club Members and Non-Members alike. More than half of all
              league members are <strong data-id="element-2623">not</strong> police officers.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2624">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-2625">
              <CalendarDaysIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-2626" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-2627">
              Fall & Winter Leagues
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2628">
              Fall leagues begin in October. Winter leagues begin in January.
              Check the calendar for specific times.
            </p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-sm border flex flex-col items-center text-center" style={{
          borderColor: '#ede9e0'
        }} data-id="element-2629">
            <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
            backgroundColor: 'rgba(30,61,47,0.08)'
          }} data-id="element-2630">
              <ClockIcon size={24} style={{
              color: '#1e3d2f'
            }} data-id="element-2631" />
            </div>
            <h3 className="text-lg font-bold uppercase mb-2" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#1e3d2f'
          }} data-id="element-2632">
              Monday Evenings
            </h3>
            <p className="text-sm" style={{
            color: '#4a6a5a',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-2633">
              The indoor range is reserved exclusively for PPC shooting on
              Monday evenings during league seasons.
            </p>
          </div>
        </div>
      </div>
    </div>;
}